'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var Button = require('@narvar/nth-button');
var Button__default = _interopDefault(Button);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// optional method that takes care of multiselect item state logic and
// returns a modified array to a callback specified by the parent component
var listOnButtonSelect = function listOnButtonSelect(multiSelectable, selectList, cb) {
  return function (index) {
    return cb(selectList.map(function (select, i) {
      return _objectSpread(_objectSpread({}, select), {}, {
        active: multiSelectable ? function (a) {
          return index !== i ? a : !a;
        }(select.active) : index === i
      });
    }));
  };
};
var ButtonMultiselect = function ButtonMultiselect(_ref) {
  var buttonTheme = _ref.buttonTheme,
    buttonProps = _ref.buttonProps,
    selectList = _ref.selectList,
    onButtonSelect = _ref.onButtonSelect;
  return /*#__PURE__*/React.createElement("div", null, selectList.map(function (_ref2, index) {
    var active = _ref2.active,
      buttonText = _ref2.buttonText;
    var buttonThemeS = buttonTheme({
      active: active
    });
    var s = _typeof(buttonThemeS) === 'object' ? buttonThemeS : Button.outline({
      active: active
    });
    return /*#__PURE__*/React.createElement("div", {
      key: buttonText
    }, /*#__PURE__*/React.createElement(Button__default, _extends({}, buttonProps, {
      s: s,
      onClick: function onClick() {
        return onButtonSelect(index);
      }
    }), buttonText));
  }));
};
ButtonMultiselect.defaultProps = {
  buttonProps: {},
  buttonTheme: function buttonTheme() {
    return undefined;
  },
  selectList: [],
  onButtonSelect: function onButtonSelect() {
    return undefined;
  }
};
ButtonMultiselect.propTypes = {
  buttonProps: PropTypes.shape(_objectSpread(_objectSpread({}, Button__default.propTypes), {}, {
    children: PropTypes.node
  })),
  buttonTheme: PropTypes.func,
  selectList: PropTypes.arrayOf(PropTypes.shape({
    buttonText: PropTypes.string,
    active: PropTypes.bool
  })),
  onButtonSelect: PropTypes.func
};

exports.default = ButtonMultiselect;
exports.listOnButtonSelect = listOnButtonSelect;
